import { render, staticRenderFns } from "./ConferenceReport.vue?vue&type=template&id=4f543fe5"
import script from "./ConferenceReport.vue?vue&type=script&lang=js"
export * from "./ConferenceReport.vue?vue&type=script&lang=js"
import style0 from "./ConferenceReport.vue?vue&type=style&index=0&id=4f543fe5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports